export default __webpack_public_path__ + "static/media/grafema_the-creativity-virus_04.2252eb51.jpg";